<template>
<div>
    <v-data-table :headers="headers"
                  :items="GetterRenseignement"
                  hide-default-footer
                  :loading="!GetterRenseignementExistant"
                  loading-text="Chargement en cours"
                  class="elevation-1">
        <template v-slot:top>
            <v-toolbar flat color="primary">
                <v-toolbar-title class="white--text">{{ GetInfosFormulaire.type }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="700px">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text dark><v-icon>mdi-plus</v-icon> Ajouter</v-btn>
                    </template>
                    <v-card class="px-6 pt-6 pb-3">
                        <v-card-title class="mb-3">
                            <span class="headline">Nouveau renseignement</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-autocomplete item-text="nom"
                                                        item-value="identifiant"
                                                        :items="GetInfosFormulaire.designations"
                                                        v-model="editedItem.designation"
                                                        label="Designation"
                                                        return-object></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.precision" label="Precision"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.pourcentage"
                                                      type="number"
                                                      min="0">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark @click="close">Annuler</v-btn>
                            <v-btn color="success" dark @click="save">Ajouter</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
            <v-snackbar v-model="snackbar"
                        :color="'error'"
                        :top="true"
                       >
                Le pourcentage total depasse 100
                <v-btn dark
                       text
                       @click="snackbar = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-snackbar>
        </template>
        <template v-slot:header.suppression>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-delete</v-icon>
            </template>
            <span>Supprimer la ligne</span>
          </v-tooltip>
        </template>
        <template v-slot:item.suppression="{ item }">
            <v-checkbox v-model="item.suppression">
            </v-checkbox>
        </template>
        <template v-slot:item.designation="{ item }">
            <v-autocomplete v-model="item.designation"
                            :items="GetInfosFormulaire.designations"
                            item-text="nom"
                            item-value="identifiant"
                            :value="item.designation.identifiant"
                            return-object>
            </v-autocomplete>
        </template>
        <template v-slot:item.precision="{ item }">
            <v-text-field v-model="item.precision">
            </v-text-field>
        </template>
        <template v-slot:item.pourcentage="{ item }">
            <v-text-field v-model="item.pourcentage"
                          type="number"
                          min="0"
                          @change="calculPourcentage()">
            </v-text-field>
        </template>
    </v-data-table>
    <div class="text-right">
      <v-btn text class="ma-3 white--text" :disabled="btnValiderDesactiver"  :loading="btnValiderLoading" color="success" @click="envoieRenseignements">
        Enregistrer
      </v-btn>
    </div>
</div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data: () => ({
            dialog: false,
            selected: [],
            headers: [
                {
                    text: 'Designation',
                    align: 'left',
                    sortable: false,
                    value: 'designation',
                },
                { text: 'Precision', value: 'precision' },
                { text: 'Pourcentage', value: 'pourcentage' },
                { text: '', value: 'suppression', sortable: false }
            ],
            editedIndex: -1,
            editedItem: {
                renseignementId: 0,
                designation: {},
                precision: '',
                pourcentage: 0,
                suppression: false
            },
            defaultItem: {
                renseignementId: 0,
                designation: {},
                precision: '',
                pourcentage: 0,
                suppression: false
            },
            pourcentageTotal: 0,
            snackbar: false,
            contactId: '',
            type: '',
            btnValiderDesactiver: false,
            btnValiderLoading: false,
            redirectUrl:''
        }),
        computed: {
            ...mapGetters('RenseignementProfessionnel', {
                GetInfosFormulaire: 'GetInfosFormulaire',
                GetterRenseignement: 'GetterRenseignement',
                GetterRenseignementExistant: 'GetterRenseignementExistant'
            }),
        },
        mounted() {
            this.contactId = this.$route.params.contactId
            this.type = this.$route.params.type
            this.redirectUrl = this.$route.params.redirect
            this.initialize()
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        methods: {
            ...mapActions({
                LoadRenseignements: 'RenseignementProfessionnel/ChargeRenseignements',
                EnvoieRenseignements: 'RenseignementProfessionnel/EnvoieRenseignements'
            }),
            async envoieRenseignements() {
                this.btnValiderLoading = true
                await this.EnvoieRenseignements().then(() => {
                    window.parent.location.href = this.redirectUrl
                    this.btnValiderLoading = false
                })
            },
            initialize() {
                this.LoadRenseignements({ contactId: this.contactId, typeRp: this.type })
            },
            editItem(item) {
                this.editedIndex = this.GetterRenseignement.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            deleteItem(item) {
                const index = this.GetterRenseignement.indexOf(item)
                this.GetterRenseignement[index].suppression = true
                confirm('Are you sure you want to delete this item?') && this.GetterRenseignement.splice(index, 1)
            },
            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
                this.calculPourcentage()
            },
            save() {
                if (this.editedIndex > -1) {
                    Object.assign(this.GetterRenseignement[this.editedIndex], this.editedItem)
                } else {
                    this.editItem.id = 0
                    this.GetterRenseignement.push(this.editedItem)
                }
                this.close()
            },
            calculPourcentage() {
                this.pourcentageTotal = 0
                this.GetterRenseignement.forEach(element => {
                    //voir pourquoi ne reste pas en number
                    this.pourcentageTotal = this.pourcentageTotal + Number(element.pourcentage)
                });
                if (this.pourcentageTotal > 100) {
                    this.snackbar = true
                    this.btnValiderDesactiver = true
                } else {
                    this.btnValiderDesactiver = false
                }
            },
        },
    }
</script>

<style scoped>
</style>